import React, { forwardRef } from 'react';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
import './CriticalActionButton.css';

interface CriticalActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactElement;
  text: React.ReactNode;
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

const CriticalActionButton = forwardRef<HTMLButtonElement, CriticalActionButtonProps>(({
  icon,
  text,
  className = '',
  size = 'small',
  ...props
}, ref) => {
  return (
    <Button
      ref={ref}
      variant="secondary"
      size={size}
      className={`critical-action-button button-destructive ${className}`}
      {...props}
    >
      <span style={{ display: 'flex', alignItems: 'center' }}>
        {icon && (
          <Icon icon={icon} className="button-icon" />
        )}
        <span className="critical-action-button-text">{text}</span>
      </span>
    </Button>
  );
});

CriticalActionButton.displayName = 'CriticalActionButton';

export default CriticalActionButton; 